import React from 'react';
import { useCallback } from 'react';
import { useMemo } from 'react';
import { useState } from 'react';
import { S2SafeParsable } from 'libs/end-to-end/src/interfaces';
import { jsonParse } from 'libs/end-to-end/src/utils/utility/json-parse';

export const useDatabaseSchemaJsonEditor = <T,>({
  currentModel,
  schema,
  onSaved,
}: {
  currentModel: T | null;
  schema: S2SafeParsable<unknown, T>;
  onSaved: (model: T) => void;
}): {
  onSaveClicked: () => {
    success: boolean;
  };
  editedJson: string;
  setEditedJson: (json: string) => void;
  currentErrorText: string | null;
} => {
  const [editedJson, setEditedJson] = useState<string>(
    JSON.stringify(currentModel, null, 2),
  );

  const [currentErrorText, setCurrentErrorText] = useState<string | null>(null);

  const onSaveClicked = useCallback(() => {
    const parseResult = jsonParse(editedJson, schema);
    if (parseResult.resultType === 'err') {
      setCurrentErrorText(parseResult.error.errorReason);
      return {
        success: false,
      };
    }

    onSaved(parseResult.value);
    return {
      success: true,
    };
  }, [editedJson, onSaved, schema]);

  return useMemo(
    () => ({
      onSaveClicked,
      editedJson,
      setEditedJson,
      currentErrorText,
    }),
    [currentErrorText, editedJson, onSaveClicked],
  );
};
